import {  Cabinet } from "./Cabinet"

const toAll = {
  Cabinet
}

export default toAll